import { ApiResponse, axiosInstance } from '@/lib/axios';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/react-query';
import { TFetchParams } from '@/types/fetch.type';
import { TTicketComment } from '../types/ticket-comment.type';

export type TGetListTicketCommentResponse = ApiResponse<TTicketComment[]>;
export type TGetListTicketCommentParams = TFetchParams & {
  ticketId: string;
};

export const getListTicketComment = async (
  params: TGetListTicketCommentParams
): Promise<TGetListTicketCommentResponse> => {
  const url = `/comment`;

  return axiosInstance.get(url, { params });
};

export const GET_LIST_TICKET_COMMENT_QUERY_KEY = 'get-list-ticket-comment';

export const getListTicketCommentQueryOptions = (params: TGetListTicketCommentParams) => {
  return queryOptions({
    queryKey: [
      GET_LIST_TICKET_COMMENT_QUERY_KEY,
      {
        ticketId: params?.ticketId,
      },
    ],
    queryFn: () => getListTicketComment(params),
  });
};

type UseListTicketCommentQueryQueryOptions = {
  params: TGetListTicketCommentParams;
  queryConfig?: QueryConfig<typeof getListTicketCommentQueryOptions>;
};

export const useListTicketCommentQuery = ({ queryConfig, params }: UseListTicketCommentQueryQueryOptions) => {
  return useQuery({
    ...getListTicketCommentQueryOptions(params),
    ...queryConfig,
  });
};
